export async function getAllItemsPexWithPoints(
  token,
  periodo,
  distribuidor,
  ano,
  referencia,
  revisao
) {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${token}`);
  myHeaders.append("Content-Type", "application/json");

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const apiUrl = `https://boanova183129.protheus.cloudtotvs.com.br:4050/rest/INT_SHELL_PEX_PONTUACAO?distribuidor=${distribuidor}&periodo=${periodo}&ano=${ano}&referencia=${referencia}&revisao=${revisao}`;

  try {
    const response = await fetch(apiUrl, requestOptions);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error get pex items:", error);
  }
}
